<template>
  <div class="vision-bar  wow fadeInDown" >
    <div class="zy-container vision">
      <div class="title">
        使命与愿景
      </div>
      <div class="line"></div>
      <div class="desc">
        <div>智莺出品 必为精品 始终坚持打造高性价比 颜值与实力并存的云系统！</div>
        <div>支持云部署 私有化部署 支持领包入住，开箱即用</div>
        <div>支持个性需求定制 支持高度个性化UI 乐高式模块组装</div>
        <div style="font-size: 18px;">书痴者文必工 艺痴者技必良 智莺数字系统 十年精心研发打磨</div>
        <div style="padding-top: 28px;">努力打造一个和谐、可持续、充满活力的公司，以期在未来实现跨越式发展</div>
        <div style="font-size: 18px;">时代风云变幻 唯紧随时潮流 数字化浪潮</div>
      </div>
    </div>
  </div>
</template>

<script>
import {WOW} from 'wowjs'
export default {
  name: "vision",
  data() {
    return {
    }
  },
  mounted() {
    this.$nextTick(() => {
      new WOW().init()
    })
  }
}
</script>

<style scoped lang="scss">
.vision-bar {
  background-repeat: no-repeat;
  background-size: 100% 100%;
  padding-top: 64px;
  padding-bottom: 64px;
}

.vision {
  display: flex;
  color: #333333;

  .title {
    flex-shrink: 0;
    font-size: 28px;
    line-height: 40px;
  }

  .line {
    width: 1px;
    height: 225px;
    background: #d8e3f5;
    margin-top: 3px;
    margin-right: 60px;
    margin-left: 60px;
  }

  .desc {
    flex-grow: 1;
    width: 564px;
    font-size: 16px;
    font-weight: 500;
    color: #333333;
    line-height: 35px;
  }
}


</style>
